module.exports = __webpack_public_path__ + "img/m301.a68ee12a.jpg";